export class MassiveAgreementService {
    getMessages(filters){
        let messages=[

        ];
        return Promise.resolve(messages);
    }
    getCatLender(){
        let catLender=[

        ];
        return Promise.resolve(catLender);
    }
    getCatBorrower(){
        let catBorrower=[

        ];
        return Promise.resolve(catBorrower);
    }
    getCatInstrument(){
        let catInstrument=[

        ];
        return Promise.resolve(catInstrument);
    }
    getCatStatus(){
        let catStatus=[
            {
                id: 1,
                status: "Procesando",
            },
            {
                id: 2,
                status: "Concertado",
            },
            {
                id: 3,
                status: "Garantizado",
            },
            {
                id: 4,
                status: "Garantizando",
            },
            {
                id: 5,
                status: "Error",
            },
            {
                id: 6,
                status: "Cancelado",
            },
        ];
        return Promise.resolve(catStatus);
    }
    getGuarantees(){
        let guarantees=[
            {
                id: 1,
                instrument: "Guarantee 1",
                series: "Series 1",
                valueType: "Tipo valor 1",
                coupon: "cupon 1"
            },
            {
                id: 2,
                instrument: "Guarantee 2",
                series: "Series 2",
                valueType: "Tipo valor 2",
                coupon: "cupon 2"
            }
        ];
        return Promise.resolve(guarantees);
    }

    saveLoanGuarantee(){
        let payload=
            {
                success: true
            };
        return Promise.resolve(payload);
    }
}